export default __webpack_public_path__ + "static/media/ModChair.b3f75e70.png";